@for(radio of config; track radio.id){
<div class="d-flex flex-column mb-2">
  <div class="form-check">
    <input
      [class]="`form-check-input bg-${radio.color || defaultConfig.color}`"
      type="radio"
      [name]="radio.id"
      [id]="radio.id"
      [checked]="selectedRadioOption == radio.id"
      [class.checked]="selectedRadioOption == radio.id"
      [disabled]="radio.disabled || defaultConfig.disabled"
      (click)="setRadioOptionChecked(radio.id)"
    />
    <label class="form-check-label fw-medium fs-9" [for]="radio.id">
      {{ radio.label.key | translate : radio.label.params }}
    </label>
  </div>

  @if(radio.childComponent && selectedRadioOption == radio.id){
  <div style="padding: 0 1.8rem">
    <ng-container
      *ngComponentOutlet="
        radio.childComponent.content;
        inputs: {
          config: radio.childComponent.data.config || undefined,
          data: radio.childComponent.data.data || undefined,
          listeners: radio.childComponent.data.listeners || undefined
        }
      "
    />
  </div>
  }
</div>
}
